import React, { use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { CrmConnectionInfo, CrmId, CrmSyncSettings } from "../../../api/crmConnectorsApi";
import type { FullResyncState, TestConnectionState } from "./crmConnectorState";

export interface CrmConnectorContextProps {
  crmName: string;
  crmApiName: CrmId;
  logoSrc: string;
  connectionInfo: CrmConnectionInfo;
  syncEnabled: boolean;
  onSyncEnabledUpdate?: (syncEnabled: boolean) => void;
  syncSettings?: CrmSyncSettings;
  onSyncSettingsUpdate?: (syncSettings: CrmSyncSettings) => void;
  testConnectionState: TestConnectionState;
  onTestConnectionStateUpdate: (state: TestConnectionState) => void;
  fullResyncState: FullResyncState;
  onFullResyncStateUpdate: (state: FullResyncState) => void;
}

export const CrmConnectorContext = React.createContext<CrmConnectorContextProps | undefined>(undefined);

export const useCrmConnectorContext = () => {
  const contextValue = use(CrmConnectorContext);
  return defined(contextValue);
};
